import { getItem } from "../utils/localStorage";
import { LOCATION_CHANGE } from "connected-react-router";

const initialState = {
  selectedReply: null,
  loadingAlternatives: true,
  loadingAnswer: true,
  playerOption: getItem("lessonPlayerOption") || "vimeo",
  id: null,
  currentTime: null,
  initialTime: null,
  requestedInitialTimeChangeAt: null,
  currentQuestionIndex: 0,
  selectedChoices: {},
};

export default function lessonReducer(state = initialState, action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return {
        ...state,
        initialTime: null,
        requestedInitialTimeChangeAt: null,
      };
    case "ANSWERS_FETCH_REQUESTED":
      return {
        ...state,
        loadingAnswer: true,
        selectedReply: null,
      };
    case "LESSON_ANSWER_FETCHED":
      return {
        ...state,
        loadingAnswer: false,
      };
    case "REPLIES_FETCH_REQUESTED":
      return {
        ...state,
        loadingAlternatives: true,
        selectedReply: null,
      };
    case "REPLIES_FETCHED":
      return {
        ...state,
        loadingAlternatives: false,
      };
    case "REPLIES_NOT_FOUND":
      return {
        ...state,
        loadingAlternatives: false,
      };
    case "REPLY_SELECTED":
      return {
        ...state,
        selectedReply: action.reply,
      };
    case "PLAYER_SELECTED":
      return {
        ...state,
        playerOption: action.option,
      };
    case "INITIAL_TIME_CHANGED":
      return {
        ...state,
        initialTime: action.initialTime,
        requestedInitialTimeChangeAt: action.requestedInitialTimeChangeAt,
      };
    case "CURRENT_TIME_UPDATED":
      return {
        ...state,
        id: action.id,
        currentTime: action.currentTime,
      };
    case "LESSON_QUESTION_INDEX_CHANGED":
      return {
        ...state,
        currentQuestionIndex: action.index,
      };
    case "CHOICE_SELECTED":
      return {
        ...state,
        selectedChoices: {
          ...state.selectedChoices,
          [action.questionId]: {
            ...(state.selectedChoices[action.questionId] || {}),
            [action.questionStemId]: action.choiceId,
          },
        },
      };
    default:
      return state;
  }
}
